import { render, staticRenderFns } from "./BackdoorMockSound.vue?vue&type=template&id=8f99ef74&scoped=true"
import script from "./BackdoorMockSound.vue?vue&type=script&lang=js"
export * from "./BackdoorMockSound.vue?vue&type=script&lang=js"
import style0 from "./BackdoorMockSound.vue?vue&type=style&index=0&id=8f99ef74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f99ef74",
  null
  
)

export default component.exports